import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    simulationID: null,
    genderValue: "Uomo",
    ageValue: "31-40",
    yearValue: "7",
    capitalValue: 130000,
    generaliPlusValue: false,
    generaliBilanciaValue: false,
    areaValue: [],
    extraProtectionValue: [],
    scenarios: []
  },
  mutations: {
    setSimulationID(state, value) {
      state.simulationID = value;
    },
    setGenderValue(state, value) {
      state.genderValue = value;
    },
    setAgeValue(state, value) {
      state.ageValue = value;
    },
    setYearValue(state, value) {
      state.yearValue = value;
    },
    setCapitalValue(state, value) {
      state.capitalValue = value;
    },
    setAreaValue(state, value) {
      state.areaValue = value;
    },
    setExtraProtectionValue(state, value) {
      state.extraProtectionValue = value;
    },
    setScenarios(state, value) {
      state.scenarios = value;
    },
    setGeneraliPlusValue(state, value) {
      state.generaliPlusValue = value;
    },
    setGeneraliBilanciaValue(state, value) {
      state.generaliBilanciaValue = value;
    }
  },
  actions: {}
});
